import { useAuth } from '../../../providers/AuthProvider';
import { useState } from 'react';
import { PageURL } from 'router/pageURL';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from 'components/common';
import { Avatar } from '@mui/material';
import { FullMenu } from 'components/FullMenu';
import { IFullMenuOption } from 'components/FullMenu/types';
import { useQueryClient } from '@tanstack/react-query';

export const ProfileSettings = () => {
  const { signOut, email } = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const openUserMenuHandler = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const closeUserMenuHandler = () => setAnchorElUser(null);

  const logoutHandler = async () => {
    setAnchorElUser(null);
    await signOut();

    queryClient.clear();
    await queryClient.invalidateQueries(['get-user']);

    navigate(PageURL.LOGIN);
  };

  return (
    <ProfileSettingsBody
      openUserMenuHandler={openUserMenuHandler}
      logoutHandler={logoutHandler}
      anchorElUser={anchorElUser}
      closeUserMenuHandler={closeUserMenuHandler}
      email={email}
    />
  );
};

type ProfileSettingsBodyProps = {
  email?: string;
  openUserMenuHandler: (event: React.MouseEvent<HTMLElement>) => void;
  logoutHandler: () => Promise<void>;
  anchorElUser: null | HTMLElement;
  closeUserMenuHandler: () => void;
};

const ProfileSettingsBody = ({
  email,
  openUserMenuHandler,
  logoutHandler,
  anchorElUser,
  closeUserMenuHandler,
}: ProfileSettingsBodyProps) => {
  const userProfileMenuOptions: IFullMenuOption[] = [{ textId: 'auth.logout.title', onClick: logoutHandler }];

  return (
    <div className={'flex items-center gap-3 ml-2'}>
      {email}
      <Tooltip title={'Open settings'}>
        <IconButton onClick={openUserMenuHandler} sx={{ p: 0 }}>
          <Avatar />
        </IconButton>
      </Tooltip>

      <FullMenu menuOptions={userProfileMenuOptions} onMenuClose={closeUserMenuHandler} anchorElement={anchorElUser} />
    </div>
  );
};
